import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { InvoiceDocument } from '../../../../models/accounting/shared/invoice-document';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { DealerSvc } from '../../../../shared/services/dealer-service';
import { StatusCode } from '../../../../utils/api';
import { PageNames } from '../../../../utils/app-constants';
import { DealerCreditRow } from '../components/DealerCreditRow';
import { DealerCredit } from '../../../../support/models/dealers/dealer-credit';
import { DealerCreditSearchFilter } from '../../../../support/models/dealers/dealer-credit-search-filters';
import { DealerRead } from '../../../../support/models/dealers/dealer-read';
import { UpdateCreditReversalStatusCommand } from '../../../../support/models/dealers/update-dealer-credit';
import '../../../../support/styles.scss';

interface IProps {
    dealer: DealerRead;
}

export const DealerCreditsScene = (props : IProps) => {

    const dispatch = useDispatch();
    const [service] = React.useState(new DealerSvc());
    const [filterParams, setFilterParams]   = React.useState(new DealerCreditSearchFilter(props.dealer.id));
    
    const [credits, setCredits]       = React.useState(() => {
        const initial = new PagedApiResult<DealerCredit>();
        initial.pagination = filterParams.paginationInfo;
        initial.pagination.reusePaging = true;
        return initial;
    });

    /**
     * OnSearch handler
     * @param filters The list of filters to apply to the search
     */
    const onSearch = async (filters: DealerCreditSearchFilter) => {
        const response = await service.getDealerCredits(filters);
        if (response.status === StatusCode.Success) {
            setCredits(response.data);
            scrollTo();
        }

        setFilterParams(filters);
    };

    const onToggleReverse = async (creditId : number, creditStatus : boolean) => {

        const req = new UpdateCreditReversalStatusCommand();
        req.creditId = creditId;
        req.isReversed = !creditStatus;

        const result = await service.toggleDealerCredit(req);
        if (result.status === StatusCode.Success) {

            const cIdx = credits.results.findIndex((itm : DealerCredit) => itm.id === creditId);
            if (cIdx > -1) {

                const tmpResults = {...credits};
                tmpResults.results[cIdx].isReversed = !creditStatus;

                setCredits(tmpResults);
            }

        }

    };

    const onParamsUpdate = (itm : any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new DealerCreditSearchFilter(props.dealer.id);
        setFilterParams(tmp);
    };

    const downloadInvoice = async (id: number, invNumber: string) => {
        const req = new InvoiceDocument(id, invNumber);
        dispatch(getDocumentHelper(req));
    };

    return props.dealer ?
        <PageContent pageName={PageNames.SUPPORT_DEALERS_CREDITS}>
            <PageBody>

                <PagedList
                    noResultsMessage="No credits found for this dealer."
                    searchCallback={ onSearch }
                    data={ credits }
                    filterProps={ filterParams }
                    selectableClass=""
                    hideFilterBar={ true }
                    useHover={ false }
                    onFilterUpdate={ onParamsUpdate }
                    onReset={ onParamsReset }
                    reduxDispatch={ dispatch }
                    rowRenderer={(itm: DealerCredit, extraProps : any) => 
                        <DealerCreditRow
                            key={ itm.id }
                            credit={ itm }
                            downloadInvoice={ downloadInvoice }
                            reverseCredit={ onToggleReverse }
                        />
                    }
                />  
                </PageBody>
            </PageContent> 
        : null;
};
